import { SpecialBoxDefault } from './special-box-default';

export default SpecialBoxDefault;
export const SpecialBox = SpecialBoxDefault;
export * from './special-box-default';
export * from './special-box-text';
